module.exports = __webpack_public_path__ + "img/12-3.19673100.png";